export const API_TAGS = {
  CREATE_COLLECTION: 'CREATE_COLLECTION',
  UPDATE_COLLECTION: 'UPDATE_COLLECTION',
  CREATE_COLLECTION_CURRICULUM: 'CREATE_COLLECTION_CURRICULUM',
  UPDATE_COLLECTION_CURRICULUM: 'UPDATE_COLLECTION_CURRICULUM',
  UPDATE_COLLECTION_CURRICULUM_ORDER: 'UPDATE_COLLECTION_CURRICULUM_ORDER',
  COPY_ITEMS_TO_COLLECTIONS: 'COPY_ITEMS_TO_COLLECTIONS',
  MOVE_ITEMS_TO_COLLECTIONS: 'MOVE_ITEMS_TO_COLLECTIONS',
  DELETE_ITEMS_FROM_COLLECTION: 'DELETE_ITEMS_FROM_COLLECTION',
  DELETE_COLLECTION: 'DELETE_COLLECTION',
  UPDATE_COLLECTION_ORDER: 'UPDATE_COLLECTION_ORDER',
  ADD_COURSE_FROM_DEEP_BROWSE: 'ADD_COURSE_FROM_DEEP_BROWSE',
};

export const DEFAULT_DESCRIPTION = 'This collection has been recommended by your organization.';
export const DEFAULT_GRADIENT = 'blueberry';
export const DEFAULT_TITLE = 'Default Collection';

export const TITLE_MIN_LEN = 3;
export const TITLE_MAX_LEN = 80;
export const DESCRIPTION_MAX_LEN = 1000;
